import BaseReducer from "shared/types/baseReducer";
import { Action, CouponCodeViewEnum } from "./enum";
import { getCouponCodeApplicableView } from "./utils";
import { CouponCodeActionType, DispatchInterface, CouponCodePropTypes, State } from "./types";

export default class Reducer extends BaseReducer<CouponCodeActionType> implements DispatchInterface {
  static getInitialState(props: CouponCodePropTypes): State {
    return {
      applicableView: getCouponCodeApplicableView({
        showCouponCode: props.showCouponCode,
        disableCouponActions: props.disableCouponActions,
        purchaseOrderLine: props.purchaseOrderLine
      })
    };
  }

  static reducer(state: State, action: CouponCodeActionType) {
    switch (action.type) {
      case Action.SET_COUPON_CODE_VIEW:
        return { ...state, applicableView: action.payload };
      default:
        return state;
    }
  }

  public setApplicableView(payload: CouponCodeViewEnum): void {
    return this.dispatch({ type: Action.SET_COUPON_CODE_VIEW, payload });
  }
}
